import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";

export class References {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined,
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        this.dom.classList = {
            openWrapperClass: "references--open",
            openListClass: "references__list--open",
            listClass: "references__list",
        };

        onReady(() => this.init(domReference));
    }

    onReferencesClickEvent(event) {
        event.preventDefault();
        const elem = event.currentTarget;
        const list = this.dom.container.querySelector(
            `.${this.dom.classList.listClass}`,
        );
        if (list.classList.contains(this.dom.classList.openListClass)) {
            list.classList.remove(this.dom.classList.openListClass);
            this.dom.container.classList.remove(
                this.dom.classList.openWrapperClass,
            );
            elem.setAttribute("aria-expanded", false);
        } else {
            list.classList.add(this.dom.classList.openListClass);
            this.dom.container.classList.add(
                this.dom.classList.openWrapperClass,
            );
            elem.setAttribute("aria-expanded", true);
        }
    }

    /**
     * Bind events we need to the DOM-elements.
     */
    bindEvents() {
        addEvent(
            this.dom.referencesTrigger,
            "click",
            this.onReferencesClickEvent.bind(this),
        );
    }

    init(domReference) {
        this.dom.referencesTrigger = domReference.querySelectorAll(
            "button[data-toggle]",
        );
        this.bindEvents();
    }
}
